import React, { useEffect, useState } from 'react';

import { Button, Checkbox } from '@pkg/components';

import { type LootBoxId } from '@app/client';

import './_AdminEditLootBox.scss';

type AdminEditLootBoxProps = {
    id: string;
    onEmailSet: (email: string) => void;
    updateLootBox: (id: LootBoxId) => void;
    ownerId: string;
    onChecked: (checked: boolean) => void;
    onCancel: () => void;
};

const AdminEditLootBox = ({ id, updateLootBox, onEmailSet, onChecked, onCancel }: AdminEditLootBoxProps) => {
    const [email, setEmail] = useState<string>('');
    const [debounce, setDebounce] = useState<number>();
    const [checked, setChecked] = useState<boolean>(true);

    useEffect(() => {
        if (email) {
            onEmailSet(email);
        }
    }, [email, onEmailSet]);

    return (
        <div className="admin-edit-loot-box">
            <h3>Edit LootBox</h3>
            <p>{id}</p>
            <div className="content">
                <div className="transfer">
                    <h4>Set Prism Case Owner</h4>
                    <label htmlFor="lb-name" title="The email address of the user to whom this is being transferred">
                        User Email:
                    </label>
                    <input
                        type="email"
                        autoFocus={true}
                        onChange={(e) => {
                            clearTimeout(debounce);
                            setDebounce(
                                window.setTimeout(() => {
                                    setEmail(e.target.value);
                                }, 200),
                            );
                        }}
                        name="lb-name"
                    />
                    <Checkbox
                        checked={checked}
                        onChange={(e) => {
                            setChecked(e.target.checked);
                            onChecked(e.target.checked);
                        }}
                        id="lootbox-checkbox"
                    >
                        <label title='If unchecked Status will be "Owned"'>Open this Lootbox on transfer?</label>
                    </Checkbox>

                    <br />
                    <div className="btn-holder">
                        <Button size="xsmall" color="secondary" onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button size="xsmall" variant="solid" color="primary" onClick={() => updateLootBox(id)}>
                            Update
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AdminEditLootBox;
